import { render, staticRenderFns } from "./BtnSaveSelectionAs.vue?vue&type=template&id=80bce9c2&scoped=true"
import script from "./BtnSaveSelectionAs.vue?vue&type=script&lang=js"
export * from "./BtnSaveSelectionAs.vue?vue&type=script&lang=js"
import style0 from "./BtnSaveSelectionAs.vue?vue&type=style&index=0&id=80bce9c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bce9c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80bce9c2')) {
      api.createRecord('80bce9c2', component.options)
    } else {
      api.reload('80bce9c2', component.options)
    }
    module.hot.accept("./BtnSaveSelectionAs.vue?vue&type=template&id=80bce9c2&scoped=true", function () {
      api.rerender('80bce9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/BtnSaveSelectionAs.vue"
export default component.exports